import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;

  > div {
    margin-right: 5px;
  }

  > div:last-child {
    margin-right: 0px;
  }
`

export const FormattedDuration = ({ duration, className }) => {
  if (!duration) return '-'

  const hours = Math.trunc(duration / 60)
  const minutes = duration % 60

  return (
    <Wrapper className={className}>
      {hours > 0 && <div>{`${hours} h`}</div>}

      {minutes > 0 && <div>{`${minutes} min`}</div>}
    </Wrapper>
  )
}
